import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { StoreWelcome } from './StoreWelcome';

export function ProviderNav({ onSignOut }) {
  const location = useLocation();
  const path = location.pathname;

  const isActive = (href) =>
    href === '/provider/'
      ? path === '/provider/' || path === '/provider'
      : path.startsWith(href);

  return (
    <header className="provider-header">
      <StoreWelcome />
      <nav className="provider-nav" aria-label="Main">
        <Link
          to="/provider/"
          className={`provider-nav-link${isActive('/provider/') ? ' provider-nav-link--active' : ''}`}
        >
          My account
        </Link>
        <Link
          to="/provider/manual"
          className={`provider-nav-link${isActive('/provider/manual') ? ' provider-nav-link--active' : ''}`}
        >
          Manual
        </Link>
        <Link
          to="/provider/billing"
          className={`provider-nav-link${isActive('/provider/billing') ? ' provider-nav-link--active' : ''}`}
        >
          Billing
        </Link>
        <Link
          to="/provider/profile"
          className={`provider-nav-link${isActive('/provider/profile') ? ' provider-nav-link--active' : ''}`}
        >
          Profile
        </Link>
        <button
          type="button"
          className="provider-nav-link provider-nav-link--danger"
          onClick={onSignOut}
        >
          Sign out
        </button>
      </nav>
    </header>
  );
}

export default ProviderNav;
